import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import { getAuthorities } from "../../../../../../../_helpers/Helpers";
import * as actions from "../../../../_redux/user-assignment/UserAssignmentAction";
import * as uiHelpers from "../PersonnelUsersUIHelpers";
import { 
  getSelectRow, 
  getHandlerTableChange,
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../../_metronic/_partials/controls";
import { usePersonnelUsersUIContext } from "../PersonnelUsersUIContext";

export function PersonnelUsersTable({
  removeUsers
}) {
  // Personnel Users UI Context
  const personnelUsersUIContext = usePersonnelUsersUIContext();
  const personnelUsersUIProps = useMemo(() => {
    return {
      ids: personnelUsersUIContext.ids,
      setIds: personnelUsersUIContext.setIds,
      queryParams: personnelUsersUIContext.queryParams,
      setQueryParams: personnelUsersUIContext.setQueryParams
    };
  }, [personnelUsersUIContext]);

  // Getting curret state of Personnel Users list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.userAssignment }),
    shallowEqual
  );
  const { totalCount, entities, authorities, listLoading } = currentState;

  // Authority Parameters
  const { isDeletionAuthorized } = getAuthorities(authorities);
  
  // Personnel Users Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getPersonnelUserAndUserGroups(personnelUsersUIProps.queryParams));
    return () => dispatch(actions.cleanUsers());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personnelUsersUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "tcKimlikNo",
      text: "TC Kimlik No",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "name",
      text: "Adı",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "surname",
      text: "Soyadı",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "personnelType",
      text: "Personel Türü",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "userGroup",
      text: "Kullanıcı Grubu",
      sort: true,
      sortCaret: sortCaret
    }
  ];

  const actionColumn = {
    dataField: "action",
    text: "İşlemler",
    formatter: columnFormatters.ActionsColumnFormatter,
    formatExtraData: {
      isDeletionAuthorized,
      removeUsers
    },
    classes: "text-center",
    headerClasses: "text-center",
    style: {
      width: "90px",
    }
  }
  
  if (isDeletionAuthorized) columns.push(actionColumn);

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: personnelUsersUIProps.queryParams.pageSize,
    page: personnelUsersUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ?? []}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                personnelUsersUIProps.setQueryParams
              )}
              selectRow={getSelectRow({
                entities,
                ids: personnelUsersUIProps.ids,
                setIds: personnelUsersUIProps.setIds,
                hidden: !isDeletionAuthorized
              })}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}